import type { DraftChild, ParentContact } from './types';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_DIGITS_RE = /\d/g;

export const isValidEmail = (raw: string) => EMAIL_RE.test(raw.trim());

export const isValidPhone = (raw: string) => (raw.match(PHONE_DIGITS_RE) ?? []).length >= 7;

export const isParentValid = (p: ParentContact) =>
  !!p.parent_name.trim() && isValidEmail(p.parent_email) && isValidPhone(p.parent_phone);

export const canContinueChild = (d: DraftChild, p: ParentContact) =>
  !!d.child_name.trim() &&
  isParentValid(p) &&
  (d.status === 'not_coming' || d.shirt_size !== null);
